import axios from 'axios';

export const request = axios.create({
  baseURL: process.env.VITE_API_URL,
});
